import { render, staticRenderFns } from "./books.vue?vue&type=template&id=4af04e34&scoped=true"
import script from "./books.vue?vue&type=script&lang=js"
export * from "./books.vue?vue&type=script&lang=js"
import style0 from "./books.vue?vue&type=style&index=0&id=4af04e34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af04e34",
  null
  
)

export default component.exports